import Swiper, { Navigation, Pagination } from 'swiper'

const SwiperAccessories = function () {

  // configure Swiper to use modules
  Swiper.use(Navigation, Pagination);
  const els = document.querySelectorAll( '.accessories-swiper' )

  // loop through swiper sections and init Swiper
  if ( Object.keys(els).length ) {
    els.forEach( function( el ){
      const pagination = el.querySelector( '.swiper-pagination');
      const nextButton = el.querySelector( '.swiper-button-next');
      const prevButton = el.querySelector( '.swiper-button-prev');
      const swiper = new Swiper( el , {
        direction: 'horizontal',
        spaceBetween: 15,
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        centeredSlides: true,
        initialSlide: 1,
        loop: true,
        pagination: {
          el: pagination,
          clickable: true
        },
        breakpoints: {
          992: {
            slidesPerView: 3,
            navigation: {
              nextEl: nextButton,
              prevEl: prevButton
            }
          }
        }
      })
    });
  }

  $( document ).ready(function() {
      // Hover state on cards
      $('.accessories-swiper .swiper-slide').on('mouseenter', function () {
        $('.accessories-swiper .swiper-slide').addClass('fade');
        $(this).addClass('full');
      });
      $('.accessories-swiper .swiper-slide').on('mouseleave', function () {
        $('.accessories-swiper .swiper-slide').removeClass('fade');
        $(this).removeClass('full');
      });
  });

}
export default SwiperAccessories;